import { NewSingleFormComponentProps } from "../components/new_form/NewSingleFormComponent";
import { getEventMetadata, getSession } from "../helper";

export function getRoutineForm(): NewSingleFormComponentProps {
  return {
    formFields: [
      {
        type: "text",
        key: "name",
        label: "Name",
        required: true,
        placeholder: "Routine Name",
      },
      {
        type: "hardcoded",
        key: "session",
        value: getSession(),
      },
      {
        type: "multiple_text_fields",
        key: "routineItems",
        label: "Routine Items",
        placeholder: "Routine Item Name",
      },
      {
        type: "hardcoded",
        key: "eventMetadata",
        value: getEventMetadata(),
      },
    ],
    type: "single_form",
  };
}
